export const HAIRSP = ' ';
export const THINSP = ' ';
